import Modal from 'antd/lib/modal/Modal';
import Tag from 'antd/lib/tag';
import Button from 'antd/lib/button';
import Typography from 'antd/lib/typography';

import { IconCheck, IconX, IconMapPin, IconCalendar, IconUsers, IconMail, IconThermometer, IconCloud, IconDroplet, IconWind } from '@tabler/icons-react'

import styles from './strategy-modal.module.css';

export default function StrategyModal({ modalVisible, setModalVisible, isTestMode, handleSendSurvey, selectedStrategy, recipientsBysite }) {
    return (
        <Modal
        title={null}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            gap: '12px',
            padding: '20px 24px',
            marginTop: '20px',
            borderTop: '1px solid #f0f0f0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {isTestMode && (
                <Tag color="warning">Test Mode - Sending to Test Email</Tag>
              )}
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <Button 
                onClick={() => handleSendSurvey(selectedStrategy.id)}
                type="primary"
                icon={<IconMail size={16} />}
                className={styles.surveyButton}
              >
                Send Survey Email
              </Button>
              <Button onClick={() => setModalVisible(false)}>
                Close
              </Button>
            </div>
          </div>
        }
        width={800}
        className={styles.strategyModal}
        getContainer={false}
      >
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <div className={styles.modalHeaderContent}>
              <h2 className={styles.modalTitle}>Storm Strategy Details</h2>
              <div className={`${styles.statusBadge} ${styles[selectedStrategy.status]}`}>
                {selectedStrategy.status === 'sent' ? (
                  <IconCheck size={16} />
                ) : (
                  <IconX size={16} />
                )}
                {selectedStrategy.status.charAt(0).toUpperCase() + selectedStrategy.status.slice(1)}
              </div>
            </div>
            <div className={styles.modalSubheader}>
              <div className={styles.modalDetail}>
                <IconMapPin size={18} />
                <span>{selectedStrategy.region}</span>
              </div>
              <div className={styles.modalDetail}>
                <IconCalendar size={18} />
                <span>{selectedStrategy.formatted_created_at}</span>
              </div>
              <div className={styles.modalDetail}>
                <IconUsers size={18} />
                <span>{selectedStrategy.site_count} sites affected</span>
              </div>
              {selectedStrategy.formatted_email_sent_at && (
                <div className={styles.modalDetail}>
                  <IconMail size={18} />
                  <span>Sent at {selectedStrategy.formatted_email_sent_at}</span>
                </div>
              )}
            </div>
          </div>

          <div className={styles.modalSection}>
            <h3 className={styles.sectionTitle}>
              Recipients by Site
              {isTestMode && <Tag color="warning" style={{ marginLeft: '8px', fontSize: '12px' }}>Test Mode</Tag>}
            </h3>
            <div className={styles.recipientsList}>
              {recipientsBysite?.map((siteData, siteIndex) => (
                <div key={siteIndex} className={styles.siteRecipients}>
                  <Tag className={styles.siteTag}>{siteData.site_name}</Tag>
                  <div className={styles.contactsList}>
                    {siteData.contacts.map((contact, contactIndex) => (
                      <Tag key={contactIndex} className={styles.emailTag}>
                        {contact.first_name} {contact.last_name} - {contact.email}
                      </Tag>
                    ))}
                    {siteData.contacts.length === 0 && (
                      <Typography.Text type="secondary" italic>No contacts assigned</Typography.Text>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.modalSection}>
            <h3 className={styles.sectionTitle}>Message</h3>
            <div className={styles.messageBox}>
              {selectedStrategy.message}
            </div>
          </div>

          <div className={styles.modalSection}>
            <h3 className={styles.sectionTitle}>Weather Conditions</h3>
            <div className={styles.weatherBox}>
              {selectedStrategy.weather_summary ? (
                <div className={styles.weatherGrid}>
                  <div className={styles.weatherGridItem}>
                    <IconThermometer size={24} className={styles.weatherIcon} />
                    <div className={styles.weatherValue}>
                      {selectedStrategy.weather_summary.temperature}°C
                    </div>
                    <div className={styles.weatherLabel}>Temperature</div>
                  </div>
                  <div className={styles.weatherGridItem}>
                    <IconCloud size={24} className={styles.weatherIcon} />
                    <div className={styles.weatherValue}>
                      {selectedStrategy.weather_summary.conditions}
                    </div>
                    <div className={styles.weatherLabel}>Conditions</div>
                  </div>
                  <div className={styles.weatherGridItem}>
                    <IconDroplet size={24} className={styles.weatherIcon} />
                    <div className={styles.weatherValue}>
                      {selectedStrategy.weather_summary.precipitation}%
                    </div>
                    <div className={styles.weatherLabel}>Precipitation</div>
                  </div>
                  <div className={styles.weatherGridItem}>
                    <IconWind size={24} className={styles.weatherIcon} />
                    <div className={styles.weatherValue}>
                      {selectedStrategy.weather_summary.wind_speed} km/h
                    </div>
                    <div className={styles.weatherLabel}>Wind Speed</div>
                  </div>
                </div>
              ) : (
                <Typography.Text type="secondary">No weather data available</Typography.Text>
              )}
            </div>
          </div>
        </div>
      </Modal>
    )
}